import { render, staticRenderFns } from "./common-modal.html?vue&type=template&id=952c0c1c&scoped=true&"
import script from "./common-modal.js?vue&type=script&lang=js&"
export * from "./common-modal.js?vue&type=script&lang=js&"
import style0 from "./common-modal.css?vue&type=style&index=0&id=952c0c1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952c0c1c",
  null
  
)

export default component.exports